<template>
  <div class="sui-spin">
    <button type="button" class="sui-spin__button sui-spin--minus" @click="onStep('minus')" :disabled="String(localValue) === String(min)">-
    </button><sui-text-field type="number" class="sui-spin__input" :value="localValue" @input="onInput"
           @blur="onBlur" ref="spinInput" :readonly="readonly" :virtual="virtual" mask="decimal">
    </sui-text-field><button type="button" class="sui-spin__button sui-spin--plus" @click="onStep('plus')" :disabled="String(localValue) === String(max)">+</button>
  </div>
</template>

<script>
/**
 * 이름 : SuiSpin
 * 설명 : 플러스 마이너스 기능을 가진 카운터 컴포넌트
 * 최종 수정 일시 : 2018 - 08 - 08
 */
export default {
  name: 'SuiSpin',
  props: {
    value: {
      type: Number,
      default: 0
    },
    step: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: 1000
    },
    min: {
      type: Number,
      default: 0
    },
    readonly: {
      type: Boolean,
      default: false
    },
    virtual: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      localValue: this.value.toString()
    }
  },
  mounted () {
    this.localValue = this.checkNumber(this.value)
  },
  watch: {
    value (newValue) {
      this.localValue = newValue.toString()
    },
    localValue (newValue) {
      this.$emit('input', Number(newValue))
    }
  },
  methods: {
    onInput (value) {
      this.localValue = this.checkNumber(value)
    },
    onBlur (param) {
      if (this.$refs.spinInput.$refs.refInput.value !== this.localValue) {
        this.$refs.spinInput.inputText(this.localValue)
      }
    },
    checkNumber (targetNum) {
      targetNum = Number(targetNum)
      if (isNaN(targetNum) || targetNum < this.min) {
        targetNum = this.min
      } else if (targetNum > this.max) {
        targetNum = this.max
      }
      return Number(targetNum.toFixed(1)).toString()
    },
    onStep (type) {
      if (type === 'plus') {
        this.localValue = this.checkNumber(Number(this.localValue) + this.step)
      } else {
        this.localValue = this.checkNumber(Number(this.localValue) - this.step)
      }
    }
  }

}
</script>

<style>

</style>
